import "./styles.css"

import { t } from "i18next"
import React, { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { useLocation } from "react-router"

import { queryClient } from "../.."
import Dropdown from "../../components/Common/Form/Dropdown"
import Modal from "../../components/Common/Modal"
import Pagination from "../../components/Common/Pagination"
import ReactEditableTable from "../../components/Common/ReactEditableTable"
import SingleSelect from "../../components/SingleSelect"
import Table from "../../components/Tables"
import ToastNotification, { notify } from "../../components/Toast"
import { userRoles } from "../../components/Utility/userRoles"
import {
    DownloadOriginalNOS,
    DownloadPriceDerivation,
    useUpdateOriginalNOS,
    useUpdateOriginalNOSCurrency,
    useUpdatePriceDerivation
} from "../../services/mutations"
import { GetAllSalesOrg, GetSalesOrgByCountrySelect, GetSalesOrgByPriceList, useGetAllPriceDrivation, useGetArticleDetails, useGetCountriesList, useGetHistoryList, useGetOriginalNOS, useGetPriceDrivation, useGetPriceListBySalesOrg, useGetPriceListNames, useGettypeNumberList } from "../../services/queries"
import { PAGINATION } from "../../utils/Constant"
import { convertDateTime, convertDateTimeByFormat, customNotification, formatPrice, getActivityIdByPathname } from "../../utils/utils"
import PriceDerivationHistory from "./PriceDerivationHistory"
import UploadPriceDerivation from "./PriceDerivationUpload"
import UploadNOSCorrection from "./UploadNOSCorrection"

const REQUIRED_VALUE = "PLEASE ENTER THE VALUE"
const OriginalNOS = () => {
    const [showPagination, setShowPagination] = useState(true)
    const [errors, setErrors] = useState({})
    const [customsearchtext, setcustomsearchtext] = useState("")
    const [pagination, setPagination] = useState(PAGINATION)
    const[pageSize,setPageSize]= useState(pagination.pageSize)
    const [loader, setLoader] = useState(false)
    const [fetchApi, setFetchApi] = useState(false)
    const [totalRecords, setTotalRecords] = useState(0)
    const [typeIdList, setTypeIdList] = useState([])
    const [data, setData] = useState([])
    const [showUploadModal, setShowUploadModal] = useState(false)
    const [showHistoryModal, setShowHistoryModal] = useState(false)
    const [historyObject, setHistoryObject] = useState({})
    const [salesOrgId, setSalesOrgId] = useState([])
    const updateOriginalNOS = useUpdateOriginalNOS(
        pagination.pageIndex,
        pageSize || pagination.pageSize
    )
    const updateOriginalNOSCurrency = useUpdateOriginalNOSCurrency(
        pagination.pageIndex,
        pageSize || pagination.pageSize
    )

    const [selectedData, setSelectedData] = useState({})
    const [filterValueDefault, setFilterValueDefault] = useState({
        saleOrg:null,
        priceList: null,
        typeNumber: null,
        eanNumber: null,
        articleNo: null,
        articleName: null,
        materialClass: null
    })
    const [newCombineFilter, setNewCombineFilter] = useState({
        saleOrg:null,
        priceList: null,
        typeNumber: null,
        eanNumber: null,
        articleNo: null,
        articleName: null,
        materialClass: null
    })

    const [filter, setFilter] = useState({
        saleOrg:[],
        priceList: [],
        typeNumber: [],
        eanNumber: [],
        articleNo: [],
        articleName: [],
        materialClass: []
    })

    const [disabledFilterItem, setDisabledFilterItem] = useState({
        eanNumber: false,
        articleNo: false,
        articleName: false,
        materialClass: false
    })

    const [key, setKey] = useState(0)

    const { t } = useTranslation()
    const location = useLocation()
    const activityId = getActivityIdByPathname(location?.pathname)
    const permissionDetails = userRoles().findUserRolesForPage(
        activityId[0]?.activity_id
    )

    const { data: countries } = useGetCountriesList()
    const { data: priceListNames } = useGetPriceListBySalesOrg(salesOrgId)
    const { data: typeNumberList } = useGettypeNumberList()
    const { data: articleDetails } = useGetArticleDetails(typeIdList)
    const { data: salesOrgList } = GetAllSalesOrg()

    const { mutateAsync: DownloadOriginalNOSList } = DownloadOriginalNOS({ search : customsearchtext,
        filter : newCombineFilter })

    const eanNumbers = articleDetails?.ean || []
    const articleNumbers = articleDetails?.article_no || []
    const articleNames = articleDetails?.article_name || []
    const materialClass = articleDetails?.material_class || []

    const countryOptions = countries?.map((country) => ({
        value: country.id,
        label: country.name
    }))

    const salesOrgOption = salesOrgList?.map((salesOrg) => ({
        value: salesOrg?.id,
        label: salesOrg?.org_code
    }))

    const priceListOption = priceListNames?.map((priceList) => ({
        value: priceList?.id,
        label: priceList?.name
    }))

    const typeNumberListOptions = typeNumberList?.data?.map((typeNumber) => ({
        value: typeNumber?.id,
        label: typeNumber?.type_no
    }))

    const eanNumberOptions = eanNumbers?.filter((obj) => obj?.value != null).map((obj) => ({
        value: obj?.id,
        label: obj?.value,
        mc: obj?.mc
    }))

    const articleNumberOptions = articleNumbers?.map((obj) => ({
        value: obj?.id,
        label: obj?.value,
        mc: obj?.mc
    }))

    const articleNameOptions = articleNames?.map((obj) => ({
        value: obj?.id,
        label: obj?.value,
        mc: obj?.mc
    }))
    
    const materialClassOptions = materialClass?.map((obj) => ({
        value: obj?.id,
        label: obj?.value
    }))

    const onPaginationClicked  = (index) => {
        setLoader(true)
        setPagination({ ...pagination, pageIndex: index })
    }

    const onSelectFilterChange = (selectedOption, filterType) => {
        const filterValues = Array.isArray(selectedOption) ? 
            selectedOption.map((option) => option?.value) : [selectedOption?.value]
        if(filterType === "priceList"){
            setErrors({
                ...errors,
                [filterType]: ""
            })
        }
        if( filterType == "salesOrg" ) {
            setSalesOrgId(filterValues)
        }

        if( filterType == "typeNumber" ) {
            if( filterValues.length > 0 ) {
                setTypeIdList(filterValues)
            } else {
                setFilter({
                    ...filter,
                    eanNumber: [],
                    articleNo: [],
                    articleName: [],
                    materialClass: []
                })
                setNewCombineFilter({
                    ...newCombineFilter,
                    eanNumber: [],
                    articleNo: [],
                    articleName: [],
                    materialClass: []
                })
                setFilterValueDefault({
                    ...filterValueDefault,
                    eanNumber: [],
                    articleNo: [],
                    articleName: [],
                    materialClass: []
                })
            }
        }

        const newFilterItems = {
            [filterType]: filterValues
        }
        const newFilterValueDefault = {
            [filterType]: selectedOption
        }

        if( filterType == "eanNumber" ) {
            if( filterValues.length > 0 ) {
                const newArticleNumberOptions = articleNumberOptions?.filter(val => filterValues.includes(val?.value))
                const newArticleNameOptions = articleNameOptions?.filter(val => filterValues.includes(val?.value))

                const articleNumberFilterValues = Array.isArray(newArticleNumberOptions) ? 
                    newArticleNumberOptions.map((option) => option.value) : [newArticleNumberOptions?.value]
                const articleNameFilterValues = Array.isArray(newArticleNameOptions) ? 
                    newArticleNameOptions.map((option) => option.value) : [newArticleNameOptions?.value]

                newFilterItems["articleNo"] = articleNumberFilterValues
                newFilterValueDefault["articleNo"] = newArticleNumberOptions

                newFilterItems["articleName"] = articleNameFilterValues
                newFilterValueDefault["articleName"] = newArticleNameOptions

                setDisabledFilterItem((data) => {
                    return {
                        ...data,
                        "articleNo": true,
                        "articleName": true
                    }
                })
                
            }
            else {
                newFilterItems["articleNo"] = []
                newFilterValueDefault["articleNo"] = null

                newFilterItems["articleName"] = []
                newFilterValueDefault["articleName"] = null
                setDisabledFilterItem((data) => {
                    return {
                        ...data,
                        "articleNo": false,
                        "articleName": false
                    }
                })
               
            }
        }

        if( filterType == "articleNo" ) {
            if( filterValues.length > 0 ) {
                const newEanOptions = eanNumberOptions?.filter(val => filterValues.includes(val?.value))
                const newArticleNameOptions = articleNameOptions?.filter(val => filterValues.includes(val?.value))

                const eanFilterValues = Array.isArray(newEanOptions) ? 
                    newEanOptions.map((option) => option.value) : [newEanOptions?.value]
                const articleNameFilterValues = Array.isArray(newArticleNameOptions) ? 
                    newArticleNameOptions.map((option) => option.value) : [newArticleNameOptions?.value]


                newFilterItems["eanNumber"] = eanFilterValues
                newFilterValueDefault["eanNumber"] = newEanOptions

                newFilterItems["articleName"] = articleNameFilterValues
                newFilterValueDefault["articleName"] = newArticleNameOptions
                setDisabledFilterItem((data) => {
                    return {
                        ...data,
                        "eanNumber": true,
                        "articleName": true
                    }
                })
            }
            else {
                newFilterItems["eanNumber"] = []
                newFilterValueDefault["eanNumber"] = null

                newFilterItems["articleName"] = []
                newFilterValueDefault["articleName"] = null
                setDisabledFilterItem((data) => {
                    return {
                        ...data,
                        "eanNumber": false,
                        "articleName": false
                    }
                })

            }
        }

        if( filterType == "articleName" ) {
            if( filterValues.length > 0 ) {
                const newEanOptions = eanNumberOptions?.filter(val => filterValues.includes(val?.value))
                const newArticleNumberOptions = articleNumberOptions?.filter(val => filterValues.includes(val?.value))

                const eanFilterValues = Array.isArray(newEanOptions) ? 
                    newEanOptions.map((option) => option.value) : [newEanOptions?.value]
                const articleNumberFilterValues = Array.isArray(newArticleNumberOptions) ? 
                    newArticleNumberOptions.map((option) => option.value) : [newArticleNumberOptions?.value]


                newFilterItems["eanNumber"] = eanFilterValues
                newFilterValueDefault["eanNumber"] = newEanOptions

                newFilterItems["articleNo"] = articleNumberFilterValues
                newFilterValueDefault["articleNo"] = newArticleNumberOptions
                setDisabledFilterItem((data) => {
                    return {
                        ...data,
                        "eanNumber": true,
                        "articleNo": true
                    }
                })
               
            }
            else {
                newFilterItems["eanNumber"] = []
                newFilterValueDefault["eanNumber"] = null

                newFilterItems["articleNo"] = []
                newFilterValueDefault["articleNo"] = null
                setDisabledFilterItem((data) => {
                    return {
                        ...data,
                        "eanNumber": false,
                        "articleNo": false
                    }
                })
            }
        }

        if( filterType == "eanNumber" || filterType == "articleNo" || filterType == "articleName" ) {
            if( filterValues.length > 0 ) {
                const selectedMCLabels = Array.isArray(selectedOption) ? 
                    selectedOption.map((option) => option?.mc) : [selectedOption?.mc]
                const selectedMCIds = materialClassOptions?.filter(obj => selectedMCLabels.includes(obj?.label))?.map(obj => obj?.value)
                const newMaterialClassOptions = materialClassOptions?.filter(val => selectedMCLabels.includes(val?.label))

                newFilterItems["materialClass"] = selectedMCIds
                newFilterValueDefault["materialClass"] = newMaterialClassOptions
                setDisabledFilterItem((data) => {
                    return {
                        ...data,
                        "materialClass": true
                    }
                })
            }
            else {
                newFilterItems["materialClass"] = []
                newFilterValueDefault["materialClass"] = null
                setDisabledFilterItem((data) => {
                    return {
                        ...data,
                        "materialClass": false
                    }
                })
            
            }
        }
        setFilter((data) => {
            return {
                ...data,
                ...newFilterItems
            }
        })
        setFilterValueDefault((data) => {
            return {
                ...data,
                ...newFilterValueDefault
            }
        })
    }

    const viewHistory = (historyRecord)=> {
        setShowHistoryModal(true)
        setHistoryObject(historyRecord)        
    }
    const countryDetail = sessionStorage?.getItem("countryDetails") && JSON.parse(sessionStorage?.getItem("countryDetails"))

    const column = [
        {
            Header: t("Pricing.country"),
            accessor: "country"
        },
        {
            Header: t("Pricing.salesorg"),
            accessor: "sales_org",
            width:100
        },
        {
            Header: t("Pricing.priceList"),
            accessor: "pricelist_name",
            width:100
        },
        {
            Header: t("calculate.typeNo"),
            accessor: "type_no",
            width:100
        },
        {
            Header: t("Pricing.articleNo"),
            accessor: "article_no",
            width:100
        },
        {
            Header: t("Pricing.articleName"),
            accessor: "article_name",
            width:100
        },
        {
            Header: t("Pricing.eanLabel"),
            accessor: "ean",
            width:100
        },
        {
            Header: t("Pricing.materialClass"),
            accessor: "material_class",
            width:100
        },
        {
            Header: t("Pricing.nosOrderOriginalPrice"),
            accessor: "nos_order_price",
            type: "input",
            width:100,
            textAlign:"right",
            Cell: ({ value }) => (
                <div className="flex flex-col">
                    <span className="text-right">{ (countryDetail && countryDetail.length>0) ? formatPrice(value) : value }</span>
                </div>
            )
        },
        {
            Header: t("Pricing.nosOrderOriginalCurrency"),
            accessor: "currency",
            width:100
        },
        {
            Header: t("Pricing.nosOrderConvertedPrice"),
            accessor: "nos_order_price_converted",
            width:100,
            textAlign:"right",
            Cell: ({ value }) => (
                <div className="flex flex-col">
                    <span className="text-right">{ (countryDetail && countryDetail.length>0) ? formatPrice(value) : value  }</span>
                </div>
            )
        },
        {
            Header: t("Pricing.nosOrderConvertedCurrency"),
            accessor: "nos_currency_converted",
            width:100
        },
        {
            Header: t("Pricing.overRides"),
            type: "bolean",
            accessor: (row) => (
                <div className="flex flex-col">
                    <span>{ row.override === true ? "Yes" : "No" }</span>
                </div>
            ),
            width:100
        },
        {
            Header: t("Pricing.history"),
            accessor: (row) => (                
                <div className="flex flex-col">
                    <span>
                        <a href="javascript:void(0)" 
                            className="text-primary-100 text-sm font-lighter underline"
                            rel="noreferrer"
                            onClick={ ()=> viewHistory(row) } >
                            View
                        </a>
                       
                    </span>
                </div>
            ),
            width:100
        },
        {
            Header: t("Pricing.validityFrom"),
            accessor: (row) => (
                <div className="flex flex-col">
                    <span>
                        { convertDateTimeByFormat(row?.valid_from, true) }
                    </span>
                </div>
            ),
            width:100
        },
        {
            Header: t("Pricing.validityTo"),
            accessor: (row) => (
                <div className="flex flex-col">
                    <span>
                        { convertDateTimeByFormat(row?.valid_to, true) }
                    </span>
                </div>
            ),
            width:100
        },
        {
            Header: t("Pricing.lastupdatedby"),
            accessor: (row) => (
                <div className="flex flex-col">
                    <span>{ row.updated_by_name }</span>{ " " }
                    <span className="text-secondary-200 text-xs">
                        { convertDateTimeByFormat(row.updated_at) }
                    </span>
                </div>
            ),
            width:100
        }
    ]

    const updateAPI = (data) => {
        let payload = {
            pid: data?.pid,
            nos_order_price : parseFloat(data?.nos_order_price),
            override: data?.override,
            import_currency_id: data?.import_currency_id
        }

        let filteredObject = filteredResult?.data.filter((item)=>{
            if(item.pid == data?.pid){
                return item
            }
        })
        if(data) {
            setLoader(true)
            updateOriginalNOS.mutate(payload, {
                onSuccess: () => { 
                    queryClient.invalidateQueries({
                        queryKey: ["originalNOS", pagination.pageIndex, pagination.pageSize]
                    })
                    queryClient.invalidateQueries({
                        queryKey: ["priceListHistory", payload?.pid]
                    })
                    setLoader(false)
                    notify("SUCCESS", t("success.recordUpdation"))
                },
                onError: (error) => {
                    setLoader(false)
                    notify("ERROR", customNotification(error?.response?.data.message, t))
                }
            })
        }
    }

    const onCustomSearch = async (searchText) => {
        if(searchText) {
            setLoader(true)
            setcustomsearchtext(searchText)
            setPagination({ ...pagination, pageIndex: 1 })
        } else {
            setcustomsearchtext("")
        }
    }

    const { data: filteredResult = [] } = useGetOriginalNOS(
        pagination.pageIndex,
        pageSize || pagination.pageSize,
        customsearchtext,
        newCombineFilter
    ) 

    useEffect(() => {
        if (filteredResult?.data) {
            setData((prevData) => {
                if (JSON.stringify(prevData) !== JSON.stringify(filteredResult.data)) {
                    return filteredResult.data
                }
                return prevData
            })
            setTotalRecords((prevTotal) => {
                if (prevTotal !== filteredResult?.total_count) {
                    return filteredResult?.total_count
                }
                return prevTotal
            })
            setLoader(false)
            setFetchApi(false)
        }
    }, [filteredResult, customsearchtext, fetchApi])

    const filterData =()=> {
        if(filter?.priceList?.length > 0){
            setPagination({
                pageIndex: 1,
                pageSize: 10
            })
            setLoader(true)
            setFetchApi(true)
            setNewCombineFilter(filter)
        }
        else {
            setErrors({
                priceList : REQUIRED_VALUE
            })
        }
    }

    const clearFilter = () => {
        setData([])
        setShowPagination(false)
        setKey((prevState)=> prevState+1)
        setFilterValueDefault({
            salesOrg:null,
            priceList: null,
            typeNumber: null,
            eanNumber: null,
            articleNo: null,
            articleName: null,
            materialClass: null
        })
        
        setFilter({
            saleOrg:[],
            priceList: [],
            typeNumber: [],
            eanNumber: [],
            articleNo: [],
            articleName: [],
            materialClass: []
        })

        setNewCombineFilter({
            saleOrg:[],
            priceList: [],
            typeNumber: [],
            eanNumber: [],
            articleNo: [],
            articleName: [],
            materialClass: []
        })
             
    }

    const onUpload = () => {
        setShowUploadModal(true)
    }

    const onUploadClose = () => {
        setShowUploadModal(false)
    }

    const onHistoryClose = ()=> {
        setShowHistoryModal(false)
    }

    const downloadObj = {
        fileName: "Original_NOS",
        sheet: "OriginalNOS"
    }

    const onDownloadData = async () => {
        try {
            setLoader(true)
            let param = {
                search : customsearchtext,
                filter : newCombineFilter
            }
            if(data?.length>0 && param.filter?.priceList) {
                let result = await DownloadOriginalNOSList( param)
                const { data: response } = result
                if (result?.status === 200 || (response?.data && response?.data?.length>0)) {
                    const newResult = response && response?.data?.map((record) => {
                        return {
                            [t("Pricing.country")]: record?.country,
                            [t("Pricing.salesorg")]: record?.sales_org,
                            [t("Pricing.priceList")]: record?.pricelist_name,
                            [t("Pricing.typeNumber")]: record?.type_no,
                            [t("Pricing.articleNo")]: record?.article_no,
                            [t("Pricing.articleName")]: record?.article_name,
                            [t("Pricing.eanLabel")]: record?.ean,
                            [t("Pricing.materialClass")]: record?.material_class,
                            [t("Pricing.nosOrderOriginalPrice")]: (countryDetail && countryDetail.length>0) ? formatPrice(record?.nos_order_price) : record?.nos_order_price,
                            [t("Pricing.nosOrderOriginalCurrency")]: record?.currency, 
                            [t("Pricing.nosOrderConvertedPrice")]: (countryDetail && countryDetail.length>0) ? formatPrice(record?.nos_order_price_converted) : record?.nos_order_price_converted,
                            [t("Pricing.nosOrderConvertedCurrency")]: record?.nos_currency_converted, 
                            [t("Pricing.overRides")]: record?.override=== true ? "Yes" : "No" ,
                            [t("Pricing.validityFrom")]: convertDateTimeByFormat(record?.valid_from, true),
                            [t("Pricing.validityTo")]: convertDateTimeByFormat(record?.valid_to, true),
                            [t("Pricing.lastupdatedby")]: `${record?.updated_by_name} ${convertDateTimeByFormat(record?.updated_at)}`
                        }
                    })
                    return newResult || []
                }
            } else {
                return []
            }
            
        } catch (ex) {
            notify("SUCCESS",customNotification(ex?.message, t))
        } finally {
            setLoader(false)
        }
    }
    const resetSelectedData = () => {
        setSelectedData({})
    }

    const onHandleChange = (e) => {
        const { name, value } = e.target
        // Regular expression to match a number with up to 2 decimal places
        const regex = /^\d+(\.\d{0,2})?$/
        // Allow empty input or values that match the regex
        if (e.target.type === "number") {
            if (value === "" || regex.test(value)) {
                setSelectedData({ ...selectedData, [name]: parseFloat(value) })

            }
        } else {
            setSelectedData({ ...selectedData, [name]: value })

        }
    }

    const onHandleToogleClick = (row,  value) => {
        setSelectedData({ ...selectedData, ["override"]: value })
    }

    const convertCurrency = () => {
        if(filteredResult?.data !== undefined && filteredResult?.data.length > 0){
            let pid = filteredResult?.data?.map(obj => obj?.pid)?.join(",")
            let payload = {
                pid : pid,
                currency_id : filteredResult?.data[0]?.currency_id,
                import_currency_id : filteredResult?.data[0]?.import_currency_id
            }
            setLoader(true)
            updateOriginalNOSCurrency.mutate(payload, {
                onSuccess: () => {                    
                    queryClient.invalidateQueries({
                        queryKey: ["originalNOS", pagination.pageIndex, pageSize]
                    })
                    setLoader(false)
                    notify("SUCCESS", t("success.recordUpdation"))
                },
                onError: (error) => {
                    setLoader(false)
                    notify("ERROR", customNotification(error?.response?.data.message, t))
                }
            })
        }
        
    }

    return (    
        <>
            <div className="flex flex-col bg-white py-4 rounded-lg gap-4 border border-secondary-300">
                <div className="flex justify-between gap-4 items-center px-4">
                    <h3 className="text-md font-black text-primary-50">
                        { `${t("Pricing.originalNos")}` }</h3>
                    <div>
                        <button type="button" 
                            className="text-blue bg-white border border-solid hover:border-0 hover:bg-primary-150 border-primary-50 font-bold text-primary-50 text-sm h-9 px-4 outline-none focus:outline-1 focus:outline-black rounded-full disabled:bg-primary-150 disabled:text-secondary-50 disabled:border-0"
                            onClick={ () => {onUpload()} }>+ { `${t("Pricing.upload")}` }
                        </button>
                    </div>
                </div>
                <div className="flex gap-4 px-4">
                    <div className="w-1/4">
                        <Dropdown
                            isMulti={ true }
                            id="country"
                            placeholder={ t("Pricing.country") }
                            name="country"
                            changeHandler={ (selectedOption) =>
                                onSelectFilterChange(selectedOption, "country")                           
                            }
                            focusIndex={ 0 }
                            isRequired={ false }  
                            options={ countryOptions }
                            isMultiWithCheckbox={ true }
                            selectedItemLength={ 1 }
                            defaultValue={ filterValueDefault?.country }                    
                            renderKey={ key }
                            AllSelectLabel = { "ALL" }
                            isAllOption = { true }
                            isValueSelect= { true }
                        />
                    </div>
                    <div className="w-1/4">
                        <Dropdown
                            isMulti={ true }
                            id="salesorg"
                            placeholder={ t("Pricing.salesorg") }
                            name="salesorg"
                            changeHandler={ (selectedOption) =>
                                onSelectFilterChange(selectedOption, "salesOrg")                           
                            }
                            focusIndex={ 0 }
                            isRequired={ false }  
                            options={ salesOrgOption }
                            isMultiWithCheckbox={ true }
                            selectedItemLength={ 1 }
                            defaultValue={ filterValueDefault?.salesOrg }
                            renderKey={ key }
                            AllSelectLabel = { "ALL" }
                            isAllOption = { true }
                            isValueSelect= { true }
                        />
                    </div>
                    <div className="w-1/4">
                        <Dropdown
                            isMulti={ false }
                            id="priceList"
                            placeholder={ t("Pricing.priceList") }
                            name="priceList"
                            changeHandler={ (selectedOption) =>
                                onSelectFilterChange(selectedOption, "priceList")                           
                            }
                            focusIndex={ 0 }
                            isRequired={ true } 
                            errorData={ errors }
                            options={ priceListOption }
                            isMultiWithCheckbox={ false }
                            selectedItemLength={ 1 }
                            defaultValue={ filterValueDefault?.priceList }
                            renderKey={ key }
                            hasSelectBoXChanged = { filterValueDefault?.priceList ? true : false }
                            isUnselectEnabled={ true }
                        />
                    </div>
                    <div className="w-1/4">
                        <Dropdown
                            isMulti={ true }
                            id="type_number"
                            placeholder={ t("Pricing.typeNo") }
                            name="type_number"
                            changeHandler={ (selectedOption) =>
                                onSelectFilterChange(selectedOption, "typeNumber")                           
                            }
                            focusIndex={ 0 }
                            isRequired={ false }  
                            options={ typeNumberListOptions }
                            isMultiWithCheckbox={ true }
                            selectedItemLength={ 1 }
                            defaultValue={ filterValueDefault?.typeNumber }
                            renderKey={ key }
                            AllSelectLabel = { "ALL" }
                            isAllOption = { true }
                            isValueSelect= { true }
                        />
                    </div>
                </div>
                <div className="flex gap-4 px-4">
                    <div className="w-1/4">
                        <Dropdown
                            isMulti={ true }
                            id="article_name"
                            placeholder={ t("Pricing.articleName") }
                            name="article_name"
                            changeHandler={ (selectedOption) =>
                                onSelectFilterChange(selectedOption, "articleName")                   
                            }
                            focusIndex={ 0 }
                            isRequired={ false }  
                            options={ articleNameOptions }
                            isMultiWithCheckbox={ true }
                            selectedItemLength={ 1 }
                            defaultValue={ filterValueDefault?.articleName }
                            isValueSelect = { true }
                            renderKey={ key }
                            AllSelectLabel = { "ALL" }
                            isAllOption = { true }
                        />
                    </div>
                    
                    <div className="w-1/4">
                        <Dropdown
                            isMulti={ true }
                            id="articleNo"
                            placeholder={ t("Pricing.articleNo") }
                            name="articleNo"
                            changeHandler={ (selectedOption) =>
                                onSelectFilterChange(selectedOption, "articleNo")                           
                            }
                            focusIndex={ 0 }
                            isRequired={ false }  
                            options={ articleNumberOptions }
                            isMultiWithCheckbox={ true }
                            selectedItemLength={ 1 }
                            defaultValue={ filterValueDefault?.articleNo }
                            isValueSelect = { true }
                            renderKey={ key }
                            AllSelectLabel = { "ALL" }
                            isAllOption = { true }
                        />
                    </div>
                    <div className="w-1/4">
                        <Dropdown
                            isMulti={ true }
                            id="ean"
                            placeholder={ t("Pricing.eanLabel") }
                            name="ean"
                            changeHandler={ (selectedOption) =>
                                onSelectFilterChange(selectedOption, "eanNumber")                           
                            }
                            focusIndex={ 0 }
                            isRequired={ false }  
                            options={ eanNumberOptions }
                            isMultiWithCheckbox={ true }
                            selectedItemLength={ 1 }
                            defaultValue={ filterValueDefault?.eanNumber }
                            isValueSelect = { true }
                            renderKey={ key }
                            AllSelectLabel = { "ALL" }
                            isAllOption = { true }
                        />
                    </div>
                    <div className="w-1/4">
                        <Dropdown
                            isMulti={ true }
                            id="material_class"
                            placeholder={ t("Pricing.materialClass") }
                            name="material_class"
                            changeHandler={ (selectedOption) =>
                                onSelectFilterChange(selectedOption, "materialClass")                           
                            }
                            focusIndex={ 0 }
                            isRequired={ false }  
                            options={ materialClassOptions }
                            isMultiWithCheckbox={ true }
                            selectedItemLength={ 1 }
                            defaultValue={ filterValueDefault?.materialClass }
                            isValueSelect = { true }
                            renderKey={ key }
                            AllSelectLabel = { "ALL" }
                            isAllOption = { true }
                        />
                    </div>
                </div>
                <div className="flex gap-4 px-4">
                    <div className="flex w-full justify-end">
                        <button
                            type="button"
                            onClick={ () => {clearFilter()} }
                            className="rounded-full border border-primary-100 text-primary-100 font-bold text-sm  hover:bg-primary-150 hover:text-primary-50 h-9 px-4 mr-4"
                        >
                            { t("Pricing.clear") }
                        </button>
                        <button
                            type="button"
                            onClick={ () => {filterData()} }
                            className="rounded-full bg-primary-100 text-white font-bold text-sm hover:bg-primary-150 hover:text-primary-50 h-9 px-4"
                        >
                            { t("Pricing.search") }
                        </button>
                    </div>
                </div>
                <div className="price-derivation-table pt-2.5">
                    <ReactEditableTable 
                        columns={ column }
                        data={ data }
                        setData={ setData }
                        updateAPI = { updateAPI }
                        translateFeature={ false }
                        onHandleToogleClick={ onHandleToogleClick }
                        customsearchtext={ customsearchtext }
                        loader={ loader }
                        downloadFeature={ true }
                        getDownloadData={ onDownloadData }
                        downloadData={ downloadObj }
                        isJsondownload = { true }
                        permissionDetails={ permissionDetails }
                        selectedData={ selectedData }
                        setSelectedData={ setSelectedData }
                        onHandleChange = { onHandleChange }
                        resetSelectedData={ resetSelectedData }
                        isCustomSearch={ true }
                        onCustomSearch={ onCustomSearch }
                        showConvertCurrency = { true }
                        convertCurrency = { convertCurrency }
                        renderKey={ key }
                    />
                    { showPagination && (
                        <Pagination
                            totalrecords={ totalRecords }
                            PaginationState={ pagination  }
                            onPaginationClicked ={ onPaginationClicked  }
                            pageSize={ pageSize }
                            setPageSize={ setPageSize }
                        />
                    ) }
                </div>
            </div>
            <>
                { showUploadModal && (
                    <Modal
                        title={ t("Pricing.uploadTitle") }
                        isCloseOnTop={ true }
                        onTopClose={ onUploadClose }
                    >
                        <UploadNOSCorrection 
                            moduleName = { "nosPriceDerivation" } 
                            template = "originalNos"
                        />
                    </Modal>
                ) }
            </>

            <>
                { showHistoryModal && (
                    <Modal
                        title={ t("Pricing.nosHistoryTilte") }
                        isCloseOnTop={ true }
                        onTopClose={ onHistoryClose }
                        customChildCssClass="max-w-[1024px]"
                    >
                        <PriceDerivationHistory
                            historyObject = { historyObject }
                            OriginalNOS = { true }
                        />
                    </Modal>
                ) }
                <ToastNotification />
            </>
        </>
    )
}

export default OriginalNOS
